module.exports = __webpack_public_path__ + "img/gota.b99ebf75.svg";